import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from 'react-router-dom';
import { useTranslation } from '../useTranslation';
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';

const Huillerie = () => {
  const { t } = useTranslation();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const category = "huilerie";
   const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const lightbox = GLightbox({
      selector: '.gallery-lightbox'
    });
    return () => {
      lightbox.destroy();
    };
  }, []);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const { data, error } = await supabase
          .from("category_images")
          .select("id, url, category")
          .eq("category", category);

        if (error) throw error;
        setImages(data);
      } catch (err) {
        console.error("Erreur de chargement des images :", err.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchEvents = async () => {
      const { data, error } = await supabase
        .from("events")
        .select("*")
        .order("date", { ascending: true });

      if (!error) setEvents(data);
      else console.error("Erreur chargement des événements :", error.message);
    };

    fetchImages();
    fetchEvents();
  }, []);

  return (
    <>
 <style>{`
    body {
      background: #0c0b09;
    }
  `}</style>
      {/* --- EVENTS SECTION --- */}
      <section id="why-us" className="why-us section-bg">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>{t('eventsTitle')}</h2>
<p>{t('eventsSubtitle')}</p>
          </div>
          <div className="row">
            {events.map((event, index) => (
              <div className="col-lg-4 mt-4 mt-lg-0" key={event.id}>
                <Link to={`/event/${event.id}`} onClick={scrollToTop} className="text-decoration-none">
                  <div
                    className="box position-relative text-white event-card"
                    data-aos="zoom-in"
                    data-aos-delay={100 + index * 100}
                    style={{
                      backgroundImage: `url('${event.image_url}')`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      height: "350px",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}>
                    <div
                      className="overlay"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        zIndex: 1,
                      }}
                    ></div>
                    <div
                      className="content position-relative p-4"
                      style={{ zIndex: 2 }}>
                      <span className="event-number">{String(index + 1).padStart(2, '0')}</span>
                      <h4>{event.title}</h4>
                      <p>{new Date(event.date).toLocaleDateString()} – {event.location}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- GALLERY SECTION --- */}
      <section id="gallery" className="gallery">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
           <h2>{t('oilMillGalleryTitle')}</h2>
<p>{t('oilMillGallerySubtitle')}</p>
          </div>
        </div>
        <div className="container-fluid" data-aos="fade-up" data-aos-delay="100">
          {loading ? (
<p className="text-center">{t('loadingImages')}</p>
          ) : images.length === 0 ? (
<p className="text-center">{t('noOilMillImages')}</p>
          ) : (
            <div className="row g-0">
              {images.map((image) => (
                <div className="col-lg-3 col-md-4" key={image.id}>
                  <div className="gallery-item">
                    <a href={image.url} className="gallery-lightbox" data-gall="gallery-item">
                      <img
                        src={image.url}
                        alt={`Image de la catégorie ${category}`}
                        className="img-fluid gallery-image"
                        style={{
                          width: '100%',
                          height: '250px',
                          objectFit: 'cover'
                        }}
                      />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Huillerie;